import { useContext, useEffect, useState } from "react";
import { } from 'react-router-dom';

import MyContext from "../context/context";

// MUI
import { CalendarMonth, EventAvailable, Login, Logout, TrendingUp } from '@mui/icons-material';
import { Alert, Box, Card, CardContent, Container, Grid, LinearProgress, Stack, Typography } from '@mui/material';
import axios from "axios";

export default function AttendanceStudent() {
    const api = useContext(MyContext)
    useEffect(() => {
        window.scroll(0, 0)
    }, [])

    const [att, setAtt] = useState([])
    const [his, setHis] = useState([])
    useEffect(() => {
        axios.get(`${api.api.student}?attendance-history`)
            .then(function (res) {
                res.data.att.status === true && setAtt(res.data.att.data)
                res.data.his.status === true && setHis(res.data.his.data)
            })
    }, [])

    // Get the number of days in the current month
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();
    const totalDays = new Date(currentYear, currentMonth + 1, 0).getDate();
    const attendancePercentage = att.attend ? Math.min((att.attend / totalDays) * 100, 100) : 0;

    return (
        <Box>
            <Container maxWidth="lg">
                <Box sx={{ py: 2 }}>
                    {/* Page Header */}
                    <Box sx={{ mb: 3 }}>
                        <Typography variant="h5" fontWeight={700} mb={1} className="orbitron">
                            Attendance Overview
                        </Typography>
                        <Typography variant="body2" color="text.secondary" fontSize={13}>
                            Monitor your daily attendance, check-in/check-out times, and view your complete attendance history.
                        </Typography>
                    </Box>

                    {/* Stats Grid */}
                    <Grid container spacing={2} mb={2}>
                        {/* Days Present */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#D1FAE5',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <EventAvailable sx={{ color: '#059669', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Days Present
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#059669">
                                        {att.attend || 0}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Attendance Rate */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#DBEAFE',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <TrendingUp sx={{ color: '#2563EB', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Attendance Rate
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#2563EB">
                                        {Math.round(attendancePercentage)}%
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Check In */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#FEF3C7',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <Login sx={{ color: '#D97706', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Today's Check In
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#D97706">
                                        {att.at_in !== null ? new Date(att.at_in).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: true }) : '--:--'}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>

                        {/* Check Out */}
                        <Grid item xs={6} md={3}>
                            <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)' }}>
                                <CardContent sx={{ p: 2 }}>
                                    <Stack direction="row" alignItems="center" spacing={1} mb={1}>
                                        <Box sx={{
                                            width: 32,
                                            height: 32,
                                            borderRadius: 1.5,
                                            backgroundColor: '#FEE2E2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center'
                                        }}>
                                            <Logout sx={{ color: '#DC2626', fontSize: 18 }} />
                                        </Box>
                                        <Typography variant="caption" color="text.secondary" fontWeight={600} fontSize={11}>
                                            Today's Check Out
                                        </Typography>
                                    </Stack>
                                    <Typography variant="h6" fontWeight={700} color="#DC2626">
                                        {att.at_out !== null ? new Date(att.at_out).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: true }) : '--:--'}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    </Grid>

                    {/* Progress Card */}
                    <Card sx={{ borderRadius: 2, backgroundColor: 'white', boxShadow: 'none', border: '1px solid', borderColor: 'rgba(0, 0, 0, 0.07)', mb: 2 }}>
                        <CardContent sx={{ p: 2 }}>
                            <Typography variant="caption" color="text.secondary" fontSize={11} mb={1.5} display="block">
                                Your attendance progress for the current period
                            </Typography>
                            <Stack direction="row" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography variant="body2" fontWeight={600} color="text.secondary">
                                    Attendance Progress
                                </Typography>
                                <Typography variant="h6" fontWeight={700} color="#059669">
                                    {att.attend || 0} / {totalDays} days
                                </Typography>
                            </Stack>
                            <LinearProgress
                                variant="determinate"
                                value={attendancePercentage}
                                sx={{
                                    height: 6,
                                    borderRadius: 3,
                                    backgroundColor: 'rgba(0,0,0,0.06)'
                                }}
                            />
                        </CardContent>
                    </Card>

                    {/* Today's Status Alert */}
                    {att.at_in === null && (
                        <Alert
                            severity="warning"
                            sx={{
                                mb: 2,
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'rgba(0, 0, 0, 0.07)',
                                fontSize: 12,
                                py: 0.5
                            }}
                        >
                            You haven't checked in today yet. Please mark your attendance.
                        </Alert>
                    )}

                    {/* Attendance History */}
                    <Box sx={{ mb: 2 }}>
                        <Typography variant="body1" fontWeight={700} mb={0.5}>
                            Attendance History ({his.length})
                        </Typography>
                        <Typography variant="caption" color="text.secondary" fontSize={11}>
                            Complete record of your daily check-in and check-out times
                        </Typography>
                    </Box>

                    {his.length === 0 ? (
                        <Alert
                            severity="info"
                            sx={{
                                borderRadius: 2,
                                border: '1px solid',
                                borderColor: 'rgba(0, 0, 0, 0.07)',
                                fontSize: 14
                            }}
                        >
                            No attendance history available yet.
                        </Alert>
                    ) : (
                        <Stack spacing={1.5}>
                            {his.map((row, i) => (
                                <Card
                                    key={i}
                                    sx={{
                                        borderRadius: 2,
                                        backgroundColor: 'white',
                                        boxShadow: 'none',
                                        border: '1px solid',
                                        borderColor: 'rgba(0, 0, 0, 0.07)'
                                    }}
                                >
                                    <CardContent sx={{ p: 2 }}>
                                        <Stack direction="row" alignItems="center" spacing={1.5} mb={1.5}>
                                            <Box sx={{
                                                width: 32,
                                                height: 32,
                                                borderRadius: 1.5,
                                                backgroundColor: '#D1FAE5',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}>
                                                <CalendarMonth sx={{ color: '#059669', fontSize: 18 }} />
                                            </Box>
                                            <Box sx={{ flexGrow: 1 }}>
                                                <Typography variant="body2" fontWeight={700}>
                                                    {new Date(row.at_in).toLocaleDateString(undefined, { weekday: 'long' })}
                                                </Typography>
                                                <Typography variant="caption" color="text.secondary" fontSize={11}>
                                                    {new Date(row.at_in).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' })}
                                                </Typography>
                                            </Box>
                                        </Stack>

                                        <Grid container spacing={2}>
                                            <Grid item xs={6}>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box sx={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: 1,
                                                        backgroundColor: '#FEF3C7',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Login sx={{ color: '#D97706', fontSize: 14 }} />
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="caption" color="text.secondary" fontSize={10}>
                                                            Check In
                                                        </Typography>
                                                        <Typography variant="body2" fontWeight={600} fontSize={13}>
                                                            {row.at_in !== null ? new Date(row.at_in).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: true }) : '--:--'}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </Grid>
                                            <Grid item xs={6}>
                                                <Stack direction="row" alignItems="center" spacing={1}>
                                                    <Box sx={{
                                                        width: 24,
                                                        height: 24,
                                                        borderRadius: 1,
                                                        backgroundColor: '#FEE2E2',
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}>
                                                        <Logout sx={{ color: '#DC2626', fontSize: 14 }} />
                                                    </Box>
                                                    <Box>
                                                        <Typography variant="caption" color="text.secondary" fontSize={10}>
                                                            Check Out
                                                        </Typography>
                                                        <Typography variant="body2" fontWeight={600} fontSize={13}>
                                                            {row.at_out !== null ? new Date(row.at_out).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit', hour12: true }) : '--:--'}
                                                        </Typography>
                                                    </Box>
                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            ))}
                        </Stack>
                    )}
                </Box>
            </Container>
        </Box>
    );
}